import { getHttpService } from './HttpService';
import { error } from '@/utils/error';

interface PrefillProductResponse {
    data: PrefillData;
}

interface PrefillResponse {
    data: PrefillData;
}

interface PrefillData {
    GeboorteDatum1?: string;
    GeboorteDatum2?: string;
    GeboorteDatum3?: string;
    GeboorteDatum4?: string;
    GeboorteDatum5?: string;
    GeboorteDatum6?: string;
    GeboorteDatum7?: string;
    GeboorteDatum8?: string;
    GeboorteDatum9?: string;
    GeboorteDatum10?: string;
    GeboorteDatum11?: string;
    GeboorteDatum12?: string;
    GeboorteDatum13?: string;
    GeboorteDatum14?: string;
    GeboorteDatum15?: string;
    GeboorteDatum16?: string;
    GeboorteDatum17?: string;
    VerzekeringBasis: string;
    VerzekeringAanvullend: string;
    VerzekeringAanvullendDoelgroep?: string;
    VerzekeringTand: string;
    EigenRisico: number;
    Collectiviteit?: number;
    Betaaltermijn?: string;
    Postcode?: string;
    Key?: string;
}

const HttpService = getHttpService();

const getProductsByQueryString = async ({
    Propositie,
    Basis,
    Aanvullend,
    Tand,
    EigenRisico
}: {
    Propositie: string;
    Basis: string;
    Aanvullend: string;
    Tand: string;
    EigenRisico: string;
}): Promise<PrefillData> => {
    const path = '/clientcontroller/prefillclient/ophalenproductenbijquerystring';
    const payload = {
        Propositie,
        Basis,
        Aanvullend,
        Tand,
        EigenRisico
    };

    const { data } = (await HttpService.post(path, payload)) as PrefillProductResponse;

    if (!data) {
        error('Client controller call was unsuccessful', {
            path,
            payload: JSON.stringify(payload)
        });
    }

    return data;
};

const getPrefillData = async (affiliateKey: string): Promise<PrefillData> => {
    const path = `/clientcontroller/prefillclient/prefilldata?prefillDataKey=${affiliateKey}`;

    const { data } = (await HttpService.get(path)) as PrefillResponse;

    if (!data) {
        error('Client controller call was unsuccessful', {
            path
        });
    }

    return data;
};

export default {
    getProductsByQueryString,
    getPrefillData
};
